<onyx-section [heading]="`${I18N}.heading`">
  <form [formGroup]="form()">
    @let controls = form().controls;
    <onyx-tabs
      data-testid="is-for-sale-tabs"
      [formControl]="controls.isForSale"
      label="labels.forSale"
      [tabs]="FOR_SALE_OPTIONS"
      [fill]="true"
      [size]="32"
      width="100%"
    ></onyx-tabs>

    <onyx-dropdown
      data-testid="ownership-type-dropdown"
      [formControl]="controls.type"
      label="labels.ownershipType"
      [options]="ownershipTypes$ | async"
      [size]="32"
    ></onyx-dropdown>

    @if (type() === OwnershipType.OWN) {
      <ng-container
        *ngTemplateOutlet="
          amountTemplate;
          context: { testId: 'vehicle-value', name: 'vehicleValue' }
        "
      ></ng-container>

      <onyx-datepicker
        data-testid="depreciation-period-datepicker"
        [formControl]="controls.depreciationPeriod"
        label="labels.depreciationPeriod"
        [showDateRange]="true"
        [yearsRange]="{ past: 10, future: 10 }"
        [size]="32"
      ></onyx-datepicker>
    } @else if (type() != null) {
      <ng-container
        *ngTemplateOutlet="
          amountTemplate;
          context: { testId: 'self-deposit', name: 'selfDeposit' }
        "
      ></ng-container>

      @if (type() !== OwnershipType.RENTAL) {
        <ng-container
          *ngTemplateOutlet="
            amountTemplate;
            context: { testId: 'buyout', name: 'buyout' }
          "
        ></ng-container>
      }

      <ng-container
        *ngTemplateOutlet="
          amountTemplate;
          context: { testId: 'installment', name: 'installment' }
        "
      ></ng-container>

      <onyx-datepicker
        data-testid="first-and-last-installment-date-datepicker"
        [formControl]="controls.firstAndLastInstallmentDate"
        label="labels.firstInstallment"
        labelTo="labels.lastInstallment"
        [showDateRange]="true"
        [size]="32"
      ></onyx-datepicker>

      @if (type() !== OwnershipType.RENTAL) {
        <onyx-text-field
          data-testid="margin-field"
          [formControl]="controls.margin"
          label="labels.margin"
          [decimalPlaces]="2"
          unit="%"
          [size]="32"
        ></onyx-text-field>

        <onyx-dropdown
          data-testid="interest-rate-type-dropdown"
          [formControl]="controls.interestRateType"
          label="labels.interestRate"
          [options]="interestRateTypes$ | async"
          [search]="true"
          [size]="32"
        ></onyx-dropdown>
      }
    }
  </form>
</onyx-section>

<ng-template let-testId="testId" let-name="name" #amountTemplate>
  @let group = form().get(name)!;
  <onyx-form-group
    [formGroup]="$any(group)"
    [label]="`labels.${name}`"
    [controls]="[group.get('value')!, group.get('currency')!]"
    (labelClick)="amountValueControlElement.focus()"
  >
    @let controls = $any(group).controls;
    <onyx-text-field
      [attr.data-testid]="`${testId}-value-field`"
      [formControl]="controls.value"
      [decimalPlaces]="2"
      [showErrors]="false"
      #amountValueControlElement
      [size]="32"
    ></onyx-text-field>

    <onyx-dropdown
      [attr.data-testid]="`${testId}-currency-dropdown`"
      [formControl]="controls.currency"
      [options]="currencies$ | async"
      [search]="true"
      width="max-content"
      [showErrors]="false"
      [size]="32"
    ></onyx-dropdown>
  </onyx-form-group>
</ng-template>
